let state = {
  
    processo_id:'',
    faturas_aluno:'',
    pagamento_id:'',
    faturas_inseridas:'',
    allProdutos:''

}

export default state